import classNames from 'classnames';

import { OurHistoryTimelineFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import { Heading3, Paragraph } from '../../../components/Text';

import textBaseStyle from '../../../components/Text/text-base.module.css';
import style from './content-details.module.css';

export type ChangeDirection = 'future' | 'past' | null;

interface ContentDetailsProps {
  changeDirection: ChangeDirection;
  selectedIndex: number;
  timeline: OurHistoryTimelineFragmentFragment[];
}

const ContentDetails = ({
  changeDirection,
  selectedIndex,
  timeline,
}: ContentDetailsProps) => {
  return (
    <ul className={style.contentDetails}>
      {timeline.map((item, index) => {
        const isFuture = index > selectedIndex;
        const isPast = index < selectedIndex;
        const isCurrent = index === selectedIndex;

        return (
          <li
            className={classNames(
              style.contentDetailItem,
              {
                [style.future]: isFuture,
                [style.past]: isPast,
                [style.current]: isCurrent,
                [style.fromFuture]: changeDirection === 'future',
                [style.fromPast]: changeDirection === 'past',
              },
            )}
            key={item.year}
          >
            {item.image && (
              <AppImage
                className={style.contentDetailItemImage}
                fallbackHeight={400}
                fallbackWidth={400}
                image={item.image}
              />
            )}

            <div className={style.textContentContainer}>
              <Heading3
                className={style.heading}
                fontColor="turquoise"
                fontSizeOverride={48}
              >
                {item.year}
              </Heading3>

              <Paragraph className={textBaseStyle.fontSize20}>
                {item.description}
              </Paragraph>

              {item.keyPoints && (
                <ul>
                  {item.keyPoints.map(keyPoint => {
                    if (keyPoint) {
                      return (
                        <li
                          className={style.keyPoint}
                          key={keyPoint.field}
                        >
                          <Paragraph
                            fontColor="turquoise"
                            fontSize={15}
                            fontWeight={700}
                          >
                            {keyPoint.field}
                            :
                          </Paragraph>

                          <Paragraph fontSize={15}>
                            {keyPoint.value}
                          </Paragraph>
                        </li>
                      );
                    }
                  })}
                </ul>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default ContentDetails;
